// extracted by mini-css-extract-plugin
module.exports = {"valueBox":"DisplayValue_valueBox__1Nb7s","rtl":"DisplayValue_rtl__1tBWp","value":"DisplayValue_value__ooLla"};